'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckBox = require('./CheckBox');

var _CheckBox2 = _interopRequireDefault(_CheckBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CheckBox2.default; /**
                                       * Copyright (c) 2015-present, Zippy Technologies
                                       *
                                       * This source code is licensed under the MIT license found in the
                                       * LICENSE file in the root directory of this source tree.
                                       */